module.exports = __webpack_public_path__ + "static/media/MY_PROJECTS.8a3a22cc.svg";